export function normalizeCheckoutId(id: string) {
  return String(id).replace('c_', '').replace('r_', '').toLowerCase();
}
